import { componentsLibraryPrimitives as primitive } from '@rbilabs/components-library';

const BRAND = process.env.REACT_APP_RBI_BRAND as string;

export const brandFont = {
  hero: 'var(--font-hero)',
  headerOne: 'var(--font-headerOne)',
  headerTwo: 'var(--font-headerTwo)',
  headerThree: 'var(--font-headerThree)',
  headerFour: primitive[BRAND].$headerFour,
  copyOne: 'var(--font-copyOne)',
  copyTwo: 'var(--font-copyTwo)',
  formUtility: primitive[BRAND].$formUtility,
};
